import { render, staticRenderFns } from "./DetailPreview.vue?vue&type=template&id=a93e09d4&scoped=true&"
import script from "./DetailPreview.vue?vue&type=script&lang=js&"
export * from "./DetailPreview.vue?vue&type=script&lang=js&"
import style0 from "./DetailPreview.vue?vue&type=style&index=0&id=a93e09d4&prod&lang=less&scoped=true&"
import style1 from "./DetailPreview.vue?vue&type=style&index=1&id=a93e09d4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93e09d4",
  null
  
)

export default component.exports